const SvgWarningIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#warning-icon_svg__a)">
      <path
        fill="url(#warning-icon_svg__b)"
        d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-6 10h-2V7h2zm0 4h-2v-2h2z"
      />
    </g>
    <defs>
      <linearGradient
        id="warning-icon_svg__b"
        x1={12}
        x2={12}
        y1={3}
        y2={21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F79133" />
        <stop offset={1} stopColor="#ED7200" />
      </linearGradient>
      <clipPath id="warning-icon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWarningIcon;
